import React from "react";
import PropTypes from "prop-types";

import defaultPostPicture from '../../../../images/mywort/default-post-picture.png';

const MAX_GRADIENT = 4;

export default class RandomGradient extends React.Component {

    static propTypes = {
        className       : PropTypes.string,
        imgClassName    : PropTypes.string,
        pictureUri      : PropTypes.string,
        randomGradient  : PropTypes.number
    };

    static defaultProps = {
        className       : "",
        imgClassName    : "",
        pictureUri      : defaultPostPicture
    };

    render() {
        let randomGradient = this.props.randomGradient >= 0 && this.props.randomGradient <= MAX_GRADIENT ? this.props.randomGradient : Math.round(Math.random() * MAX_GRADIENT);

        return (
            <div className={`${this.props.className} mywort-gradient--${randomGradient}`}>
                <img src={this.props.pictureUri} className={this.props.imgClassName}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/mywort/commons/components/RandomGradient.jsx